var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoplightYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_9760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.5C12.0196 19.5 14.4359 18.4991 16.2175 16.7175C17.9991 14.9359 19 12.5196 19 10C19 7.48044 17.9991 5.06408 16.2175 3.28249C14.4359 1.50089 12.0196 0.5 9.5 0.5C6.98044 0.5 4.56408 1.50089 2.78249 3.28249C1.00089 5.06408 0 7.48044 0 10C0 12.5196 1.00089 14.9359 2.78249 16.7175C4.56408 18.4991 6.98044 19.5 9.5 19.5ZM6.82812 9.10938H12.1719C12.6654 9.10938 13.0625 9.50644 13.0625 10C13.0625 10.4936 12.6654 10.8906 12.1719 10.8906H6.82812C6.33457 10.8906 5.9375 10.4936 5.9375 10C5.9375 9.50644 6.33457 9.10938 6.82812 9.10938Z",
    fill: "#F9EA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_9760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoplightYellow);
export default __webpack_public_path__ + "static/media/stoplight_yellow.3e68f77d52a2a2399aa23f6e03270c09.svg";
export { ForwardRef as ReactComponent };